import { ReactElement } from 'react';
import { getSchema } from '@localstack/services';
import { VPC } from '@localstack/types';

import { MagicDetails } from '../../magic/MagicDetails';

export interface VPCDetailsProps {
  vpc?: Optional<Partial<VPC>>;
}

export const VPCDetails = ({ vpc }: VPCDetailsProps): ReactElement => (
  <MagicDetails
    data={vpc}
    schema={getSchema('EC2')}
    entry="Vpc"
    title="VPC Details"
    order={['VpcId', 'CidrBlock', 'State', 'IsDefault', 'InstanceTenancy', 'OwnerId']}
  />
);
